const UPDATE_CONFIG = 'config/UPDATE_CONFIG';
const UPDATE_LOADED = 'floors/UPDATE_LOADED';

export default {
  UPDATE_CONFIG,
  UPDATE_LOADED
};
